import { createContext, useContext } from 'react';
import { centralAuthUrl } from '../../utils/env';

import {
  loginScupBackground,
  loginBnjBackground
} from 'src/pages/Branding/img';

export const realms = {
  iopp: {
    name: 'IOP Publishing',
    logoUrl:
      'https://storage.googleapis.com/morressier_publisher_logo_production/mc/logo.png',
    footerUrl:
      'https://storage.googleapis.com/morressier_publisher_logo_production/mc/logo.png',
    loginBackgroundImage: loginBnjBackground,
    signupBackgroundImage:
      'https://storage.googleapis.com/morressier_publisher_logo_production/morressier/banner.svg',
    template: 'twoColumnAuth',
    description:
      'Journal Manager is an integrated manuscript submission and publishing suite for scholarly publications. It provides end-to-end tools for authors, editors, and reviewers to manage submissions, editorial review, revisions, and final publication within a single, unified platform. Designed for flexibility and scalability, Journal Manager supports custom workflows, robust metadata management, and is compliant with academic standards.',
    isIconRequired: true
  },
  bnj: {
    name: 'Bone & Joint',
    logoUrl:
      'https://storage.googleapis.com/morressier_publisher_logo_production/mc/logo.png',
    footerUrl:
      'https://storage.googleapis.com/morressier_publisher_logo_production/mc/logo.png',
    loginBackgroundImage: loginBnjBackground,
    signupBackgroundImage:
      'https://storage.googleapis.com/morressier_publisher_logo_production/morressier/banner.svg',
    template: 'twoColumnAuthGeneric',
    description:
      'Journal Manager is an integrated manuscript submission and publishing suite for scholarly publications. It provides end-to-end tools for authors, editors, and reviewers to manage submissions, editorial review, revisions, and final publication within a single, unified platform. Designed for flexibility and scalability, Journal Manager supports custom workflows, robust metadata management, and is compliant with academic standards.',
    isIconRequired: true
  },
  m: {
    name: 'Molecular Connections',
    logoUrl:
      'https://storage.googleapis.com/morressier_publisher_logo_production/mc/logo.png',
    footerUrl:
      'https://storage.googleapis.com/morressier_publisher_logo_production/mc/logo.png',
    loginBackgroundImage: loginBnjBackground,
    signupBackgroundImage:
      'https://storage.googleapis.com/morressier_publisher_logo_production/morressier/banner.svg',
    template: 'twoColumnAuthGeneric',
    description:
      'Journal Manager is an integrated manuscript submission and publishing suite for scholarly publications. It provides end-to-end tools for authors, editors, and reviewers to manage submissions, editorial review, revisions, and final publication within a single, unified platform. Designed for flexibility and scalability, Journal Manager supports custom workflows, robust metadata management, and is compliant with academic standards.',
    isIconRequired: true
  },
  scup: {
    name: 'SCUP',
    logoUrl:
      'https://storage.googleapis.com/morressier_publisher_logo_production/scup/logo.svg',
    footerUrl:
      'https://storage.googleapis.com/morressier_publisher_logo_production/scup/logo.svg',
    loginBackgroundImage: loginScupBackground,
    signupBackgroundImage:
      'https://storage.googleapis.com/morressier_publisher_logo_production/scup/banner.png',
    template: 'twoColumnAuthGeneric',
    description: 'Submit, track and manage your papers.',
    isIconRequired: false
  },
  mag: {
    name: 'MA Healthcare',
    logoUrl:
      'https://storage.googleapis.com/morressier_publisher_logo_production/mag/logo.jpeg',
    footerUrl:
      'https://storage.googleapis.com/morressier_publisher_logo_production/mag/logo.jpeg',
    loginBackgroundImage: loginBnjBackground,
    signupBackgroundImage:
      'https://storage.googleapis.com/morressier_publisher_logo_production/morressier/banner.svg',
    template: 'twoColumnAuthGeneric',
    description:
      'Journal Manager is an integrated manuscript submission and publishing suite for scholarly publications. It provides end-to-end tools for authors, editors, and reviewers to manage submissions, editorial review, revisions, and final publication within a single, unified platform. Designed for flexibility and scalability, Journal Manager supports custom workflows, robust metadata management, and is compliant with academic standards.',
    isIconRequired: true
  },
  berghahn: {
    name: 'Berghahn Books',
    logoUrl:
      'https://storage.googleapis.com/morressier_publisher_logo_production/mc/logo.png',
    footerUrl:
      'https://storage.googleapis.com/morressier_publisher_logo_production/mc/logo.png',
    loginBackgroundImage: loginBnjBackground,
    signupBackgroundImage:
      'https://storage.googleapis.com/morressier_publisher_logo_production/morressier/banner.svg',
    template: 'twoColumnAuthGeneric',
    description:
      'Journal Manager is an integrated manuscript submission and publishing suite for scholarly publications. It provides end-to-end tools for authors, editors, and reviewers to manage submissions, editorial review, revisions, and final publication within a single, unified platform. Designed for flexibility and scalability, Journal Manager supports custom workflows, robust metadata management, and is compliant with academic standards.',
    isIconRequired: true
  }
};

export interface ClientBrand {
  logoUrl: string;
  footerUrl: string;
  loginBackgroundImage: string;
  signupBackgroundImage: string;
  name: string;
  template: string;
  description: string;
  isIconRequired: boolean;
}

type IAuthRealmContext = {
  authRealm: string;
  loginUrl: string;
  clientBrand: ClientBrand;
  getLoginUrlForAuthRealm: (authRealm: string) => string;
};

// TODO make config-driven?
export function getLoginUrlForAuthRealm(authRealm: string) {
  const base = `${centralAuthUrl}/realms/${
    import.meta.env.VITE_CENTRAL_AUTH_CLIENT_REALM
  }/protocol/openid-connect/auth`;

  const queryStringParts: Record<string, string> = {
    client_id: 'publishing-engine-keycloak',
    response_type: 'code',
    redirect_uri: window.location.href
  };

  if (authRealm === 'iopp') {
    queryStringParts.kc_idp_hint = 'ioppublishing';
  }

  const queryString = new URLSearchParams(queryStringParts);
  return `${base}?${queryString.toString()}`;
}

export function getBrandConfigForAuthRealm(authRealm: string): ClientBrand {
  return realms[authRealm as keyof typeof realms];
}

export const AuthRealmContext = createContext<IAuthRealmContext>({
  authRealm: 'm',
  loginUrl: getLoginUrlForAuthRealm('m'),
  clientBrand: getBrandConfigForAuthRealm('m'),
  getLoginUrlForAuthRealm
});

export const useAuthRealm = () => {
  const context = useContext(AuthRealmContext);
  return context;
};
